import React from "react";
import { useTranslation } from "react-i18next";
import { NoOrdersWrapper } from "../styles"

const NoOrders = () => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <NoOrdersWrapper>
        {t("youStillHaveNoOrders")}
      </NoOrdersWrapper>
    </React.Fragment>
  );
};

export default NoOrders;
